import { render, staticRenderFns } from "./IconPodcast.vue?vue&type=template&id=04dd07d1&"
import script from "./IconPodcast.vue?vue&type=script&lang=js&"
export * from "./IconPodcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports